import config from "../config";

export async function apiRequest(endpoint: string, options: any) {
  return await fetch(`${config.AUTH_API_URL}${endpoint}`, {
    credentials: "include",
    ...options
  });
}

